import { WidgetZonesUrlFormatter } from "../WidgetZonesUrlFormatter";
import { WidgetZonesOptionsFormatter } from "../WidgetZonesOptionsFormatter";
import { BaseRequestFormatter } from "../../../base";
export class WidgetZonesRequestFormatter extends BaseRequestFormatter {
    constructor(options) {
        super({
            urlFormatter: new WidgetZonesUrlFormatter(),
            optionsFormatter: new WidgetZonesOptionsFormatter(options),
        });
    }
}
//# sourceMappingURL=WidgetZonesRequestFormatter.js.map